module.exports = __webpack_public_path__ + "e1c451391d3b493018f11904d218bcff.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/youth-crew.png
// module id = 479
// module chunks = 0